

(function($) {
    
    require('./navify.js');
    const $mainMenu = $('.main-menu');
    
    $mainMenu.navify();
    // Main Navigation Links
    // var $links = $('.region-navigation-collapsible .expanded');
    // 
    // // Assign click handler to caret on dropdown
    // $links.each(function(i, el) {
    //     var $this = $(el);
    //     var $link = $this.find('[data-toggle="dropdown"]');
    //     var url = $link.attr('href');
    //     var $linkCaret = $link.find('.caret');
    //     // Setup click handler for this element
    //     $this.click(function(e) {
    //         console.log('li clicked');
    //         e.preventDefault();
    //         e.stopPropagation();
    //         window.location.href = url;
    //     });
    //     // Prevent the link click from toggling the dropdown
    //     $link.click(function(e) {
    //         console.log('link clicked');
    //         window.location.href = url;
    //         e.stopPropagation();
    //         e.preventDefault();
    //     })
    //     // Setup click handler for caret
    //     $linkCaret.click(function(e) {
    //         e.stopPropagation();
    //         e.preventDefault();
    //         $link.dropdown('toggle');
    //         console.log('caret clicked');
    //     });
    // });
    
    
    // Prevent links from opening drop down, and load link href
    // $links.click(function(e) {
    //     console.log('link clicked');
    //     e.preventDefault();
    //     e.stopPropagation();
    //     window.location.href = e.target.href;
    // });
})(jQuery)
